import * as yup from 'yup';
import { validateCompanySsn } from '../../helpers/formHelpers/formHelpers';

export interface ICompanyDebitForm {
	identificationNumber: string;
	nameOfCompany: string;
	email: string;
	name: string;
	numberOfRegularLetters: string;
	numberOfEuropeanLetters: string;
	numberOfLettersOutsideEurope: string;
	reference: string;
	countLetters: boolean;
}

export const stepInfoInitialValues: ICompanyDebitForm = {
	identificationNumber: '',
	nameOfCompany: '',
	email: '',
	name: '',
	numberOfRegularLetters: '',
	numberOfEuropeanLetters: '',
	numberOfLettersOutsideEurope: '',
	reference: '',
	countLetters: false,
};

function validateCount() {
	return (
		this.parent.numberOfRegularLetters ||
		this.parent.numberOfEuropeanLetters ||
		this.parent.numberOfLettersOutsideEurope ||
		this.parent.countLetters === true
	);
}

export const CompanyDebitFormSchema = yup.object().shape({
	identificationNumber: yup
		.string()
		.required('socialIdRequired')
		.min(9, 'socialIdMinimum')
		.test('is-valid-socialId', 'socialIdValid', validateCompanySsn),
	nameOfCompany: yup.string(),
	email: yup.string().required('required').email('email-format').max(60),
	name: yup.string().required('required').max(12, 'name-length'),
	numberOfRegularLetters: yup
		.string()
		.matches(/^[0-9]+$/, 'onlyNumbers')
		.max(5, 'numberslength')
		.test('validateCount', 'validateMultiple', validateCount),
	numberOfEuropeanLetters: yup
		.string()
		.matches(/^[0-9]+$/, 'onlyNumbers')
		.max(5, 'numberslength')
		.test('validateCount', 'validateMultiple', validateCount),
	numberOfLettersOutsideEurope: yup
		.string()
		.matches(/^[0-9]+$/, 'onlyNumbers')
		.max(5, 'numberslength')
		.test('validateCount', 'validateMultiple', validateCount),
	reference: yup.string().max(35),
	countLetters: yup.boolean().test('validateCount', 'validateMultiple', validateCount),
});
